import React from 'react';
import { ROUTES } from './util/routes';

/**
 * Path → page, for every page that is not the editor. Each is its own chunk.
 *
 * The editor at `/` is what almost every visit opens, and it is bundled with the app. These
 * pages used to be bundled with it too, so opening the editor downloaded all of them as well
 * (~11% of the main bundle, measured 2026-10-08 — see the App.tsx breakup plan, step 7). Now a
 * page's code loads only when its URL is visited.
 *
 * Exact paths only. The slice page's `/s/:id` (and the legacy `/slice/:id`), the admin page
 * and the `/meow-mix` redirect stay in App's router, which reads the id or redirects.
 */
export const MySlices = React.lazy(() => import(/* webpackChunkName: "my-slices" */ './views/MySlices'));
export const SlicePage = React.lazy(() => import(/* webpackChunkName: "slice-page" */ './views/SlicePage'));
// Exported like SlicePage: `/help/<slug>` is a prefix route App.tsx resolves itself.
export const Help = React.lazy(() => import(/* webpackChunkName: "help" */ './views/Help'));
const About = React.lazy(() => import(/* webpackChunkName: "about" */ './views/About'));
const Pricing = React.lazy(() => import(/* webpackChunkName: "pricing" */ './views/Pricing'));
const BillingSuccess = React.lazy(() => import(/* webpackChunkName: "billing-success" */ './views/BillingSuccess'));
const BillingCancel = React.lazy(() => import(/* webpackChunkName: "billing-cancel" */ './views/BillingCancel'));
const Settings = React.lazy(() => import(/* webpackChunkName: "settings" */ './views/Settings'));
const Faq = React.lazy(() => import(/* webpackChunkName: "faq" */ './views/Faq'));
const Terms = React.lazy(() => import(/* webpackChunkName: "terms" */ './views/Terms'));
const Privacy = React.lazy(() => import(/* webpackChunkName: "privacy" */ './views/Privacy'));
const Releases = React.lazy(() => import(/* webpackChunkName: "releases" */ './views/Releases'));
const Contact = React.lazy(() => import(/* webpackChunkName: "contact" */ './views/Contact'));

export const PAGES: Record<string, React.LazyExoticComponent<React.ComponentType>> = {
  '/my-slices': MySlices,
  [ROUTES.ABOUT]: About,
  [ROUTES.PRICING]: Pricing,
  '/billing/success': BillingSuccess,
  '/billing/cancel': BillingCancel,
  [ROUTES.SETTINGS]: Settings,
  [ROUTES.FAQ]: Faq,
  [ROUTES.HELP]: Help,
  [ROUTES.PRIVACY]: Privacy,
  [ROUTES.TERMS]: Terms,
  [ROUTES.RELEASES]: Releases,
  [ROUTES.CONTACT]: Contact,
};
